import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const WalletIcon = ({ size = defaultSize }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M2 7C2 5.34315 3.34315 4 5 4H17C18.6569 4 20 5.34315 20 7V9.17071C21.1652 9.58254 22 10.6938 22 12C22 13.3062 21.1652 14.4175 20 14.8293V17C20 18.6569 18.6569 20 17 20H5C3.34315 20 2 18.6569 2 17V7ZM18 15H16C14.3431 15 13 13.6569 13 12C13 10.3431 14.3431 9 16 9H18V7C18 6.44772 17.5523 6 17 6H5C4.44772 6 4 6.44772 4 7V17C4 17.5523 4.44772 18 5 18H17C17.5523 18 18 17.5523 18 17V15ZM16 11C15.4477 11 15 11.4477 15 12C15 12.5523 15.4477 13 16 13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H16Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

WalletIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(WalletIcon);
